'use client'

import * as React from 'react'
import { MessageCircle, Phone } from 'lucide-react'
import { useTranslations } from 'next-intl'
import { cn } from '@/lib/utils'

export interface FloatingButtonsProps {
  ctaHref?: string
  chatHref?: string
  className?: string
}

export function FloatingButtons({ ctaHref, chatHref, className }: FloatingButtonsProps) {
  const t = useTranslations('floatingButtons')

  return (
    <div className={cn('fixed bottom-6 right-6 z-40 flex flex-col gap-3', className)}>
      {ctaHref && (
        <a
          href={ctaHref}
          className="group inline-flex h-14 w-14 items-center justify-center rounded-full bg-grad-cta text-white shadow-[0_10px_30px_-6px_rgba(43,90,255,0.5)] transition-transform hover:-translate-y-0.5"
          aria-label={t('bookCall')}
        >
          <Phone size={20} strokeWidth={2} />
        </a>
      )}
      {chatHref && (
        <a
          href={chatHref}
          className="inline-flex h-14 w-14 items-center justify-center rounded-full border border-border bg-white text-text-primary shadow-sm hover:border-blue/40"
          aria-label={t('openChat')}
        >
          <MessageCircle size={20} strokeWidth={2} />
        </a>
      )}
    </div>
  )
}
